import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './style.scss';
import Img from 'components/common/Img';

const Loading = ({ msg, icon, style, className }) => {
  const loadingClassName = cn('webim-loading', {
    [className]: className,
  });
  return (
    <div className={loadingClassName} style={style}>
      <Img src={icon} alt={icon ? 'icon' : ''} />
      <span>{msg}</span>
    </div>
  );
};

Loading.propTypes = {
  msg: PropTypes.string,
  style: PropTypes.object,
  icon: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;
